import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { List } from 'immutable';
import { kebabCase } from 'lodash';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';

@Component({
  selector: 'app-credit-cards',
  templateUrl: './credit-cards.component.html',
  styleUrls: ['./credit-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditCardsComponent implements OnInit, OnChanges {
  @Input() cards: List<string>;

  icons: List<IIcon>;

  constructor() {}

  ngOnChanges(changes) {
    if (changes.cards && this.cards) {
      this.icons = this.cards.map((brand: string) => {
        return {
          name: `card-${kebabCase(brand)}`,
          size: IconSizesEnum.custom,
        };
      }) as List<IIcon>;
    }
  }

  ngOnInit() {}
}
